export default __webpack_public_path__ + "media/images/images_v2/double-fleche-upping-0ba46ab4e423fa31be7fc3d2f08d1b0d.png";